import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

const GetMapGroupScreens = async (queryParams) => {
  const token = await getAccessToken();
  queryParams = queryParams || {};
  const params = new URLSearchParams();
  let paramCount = 0;

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && value !== undefined) {
      params.append(key, value);
      paramCount++;
    }
  });

  let url = `${config.API_URL}/map-group-screens`;

  if (paramCount > 0) {
    url += `?${params.toString()}`;
  }

  let headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  };

  try {
    return await apiClient.get(url, {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const GetMapGroupScreenById = async (id) => {
  const token = await getAccessToken();
  let url = `${config.API_URL}/map-group-screens/${id}`;

  let headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  };

  try {
    return await apiClient.get(url, {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const SearchMapGroupScreens = async (queryParams) => {
  const token = await getAccessToken();
  const params = new URLSearchParams();
  let paramCount = 0;

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && value !== undefined) {
      params.append(key, value);
      paramCount++;
    }
  });

  let url = `${config.API_URL}/map-group-screens/search`;
  if (paramCount > 0) {
    url += `?${params.toString()}`;
  }

  let headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  };

  try {
    return await apiClient.get(url, {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const CreateMapGroupScreen = async (createMapGroup) => {
  const token = await getAccessToken();
  let url = `${config.API_URL}/map-group-screens`;

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };

  try {
    return await apiClient.post(url, JSON.stringify(createMapGroup), {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const UpdateMapGroupScreen = async (id, updateMapGroup) => {
  const token = await getAccessToken();
  let url = `${config.API_URL}/map-group-screens/${id}`;
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };

  try {
    return await apiClient.put(url, JSON.stringify(updateMapGroup), {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const DeleteMapGroupScreen = async (id) => {
  const token = await getAccessToken();
  let url = `${config.API_URL}/map-group-screens/${id}`;

  let headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  };

  try {
    return await apiClient.delete(url, {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const MapGroupScreenService = {
  GetMapGroupScreens,
  GetMapGroupScreenById,
  SearchMapGroupScreens,
  CreateMapGroupScreen,
  UpdateMapGroupScreen,
  DeleteMapGroupScreen,
};

export default MapGroupScreenService;
